import {makeStyles} from "@material-ui/core";
const useStyles = makeStyles(theme => ({
    root: {
        marginBottom: 16,
        color: "white",
        fontFamily: 'XfinityBrown'
    }
}))

export default useStyles